<script setup>
import { computed } from 'vue';

const props = defineProps({
  columns: {
    type: Number,
    default: 3,
    validator: value => [2, 3, 4].includes(value),
  },
});

const gridClass = computed(() => {
  const classes = {
    2: 'sm:grid-cols-2',
    3: 'sm:grid-cols-2 xl:grid-cols-3',
    4: 'sm:grid-cols-2 xl:grid-cols-4',
  };

  return classes[props.columns];
});
</script>

<template>
  <div class="grid grid-cols-1 gap-4" :class="gridClass">
    <slot />
  </div>
</template>
